<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <div class="modal_header">
        <h5> Resource Types </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()" />
      </div>
      <div class="modal_body">
        <div class="form_wrap">
          <table class="form_table">
            <colgroup>
              <col width="250px"/>
              <col/>
            </colgroup>
            <thead>
              <tr>
                <th style="font-weight: 500;text-align: center;">Resource</th>
                <th style="font-weight: 500;text-align: center;">Types</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="font-weight:400">EC2</td>
                <td style="font-weight: 400;line-height: 2;">
                  .AWS : EC2<br/>
                  .Azure : Virtual machines, SQL Virtual Machines<br/>
                  .GCP : Compute Engine<br/>
                  .Ali : ECS<br/>
                  .NCP : Server<br/>
                  .OCI : Instance<br/>
                  .SCP : Server
                </td>
              </tr>
              <tr>
                <td style="font-weight:400">RDS</td>
                <td style="font-weight: 400;line-height: 2;">
                  .AWS : RDS(Amazon Aurora, MariaDB, MySQL, Oracle, PostgreSQL, SQL Server)<br/>
                  .Azure : SQL Managed Instances, MySQL Flexible Servers, PostgreSQL Flexible Servers, Synapse Analytics, SQL Servers(SQL Database)<br/>
                  .Ali : AsparaDB(MSSQL, MYSQL)<br/>
                  .NCP : MySQL<br/>
                  .OCI : MySQL, Oracle Base Database Service<br/>
                  .SCP : MariaDB, MySQL, PoatgreSQL, SQL Server
                </td>
              </tr>
              <tr>
                <td style="font-weight:400">S3/DynamoDB/Storage Account</td>
                <td style="font-weight: 400;line-height: 2;">
                  .AWS : S3, DynomoDB<br/>
                  .Azure : Storage Account
                </td>
              </tr>
              <tr>
                <td style="font-weight:400">GCP Service</td>
                <td style="font-weight: 400;line-height: 2;">
                  .GCP : Cloud Function, Cloud Bigtable, Datastore, BigQuery, Filestore, Cloud Storage
                </td>
              </tr>
              <tr>
                <td style="font-weight:400">Etc.</td>
                <td style="font-weight: 400;line-height: 2;">
                  .AWS : Neptune, EFS<br/>
                  .Azure : Azure Cache for Redis, Azure Cosmos DB for NoSQL, Azure Cosmos DB for MongoDB (RU), Azure Cosmos DB for MongoDB (vCore Cluster),<br/>
                  <span style="padding-left: 50px;">Azure Cosmos DB for Table, Azure Cosmos DB for Gremlin, Azure Cosmos DB for Apache Cassandra (RU)</span><br/>
                  .GCP : Cloud SQL(MySQL)
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="close()">{{ $t('sdl.common.label.close') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  data() {
    return {}
  },
  methods: {
    close() {
      if (!this.isChange) this.$emit('close');
      else this.popupClose();
    },
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/view/rem/permissionManager/resource/popup/ResourceTypesPopup.vue